import * as React from 'react'

import { Table } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import usePagination from 'modules/core/hooks/usePagination'
import i18n from 'modules/core/lib/i18n'

import type { SupplementType } from 'modules/payroll_bundle/components/common/helper/worksheet'
import type Supplement from 'modules/payroll_bundle/store/models/Supplement'

import Item from './_Item'

interface Props {
  supplements: Supplement[]
  supplementTypes: SupplementType[]
  selected?: Set<string>
  checkable?: boolean
  onSelectAll?: () => void
  onSelectItem?: (supplement: Supplement) => void
  onAssignEmployee: (userId: string, index: string) => void
}

const GroupBody = ({
  supplements,
  supplementTypes,
  selected,
  checkable,
  onSelectItem,
  onAssignEmployee,
}: Props) => {
  const { paginatedItems, loadMore, hasMore, page } = usePagination({
    batchSize: 50,
    items: supplements,
  })

  if (supplements.length === 0) {
    return (
      <Table.Body>
        <Table.Blank
          colSpan={6}
          text={i18n.t('payroll_bundle.supplements.bulk_import.table.no_supplement')}
        />
      </Table.Body>
    )
  }

  return (
    <Table.BodyWithInfiniteScroll page={page} loadMore={loadMore} hasMore={hasMore} colSpan={6}>
      <Table noRadius hideBorder>
        {paginatedItems.map((supplement) => (
          <Item
            key={supplement.id}
            selected={selected}
            checkable={checkable}
            supplement={supplement}
            supplementTypes={supplementTypes}
            onSelectItem={onSelectItem}
            onAssignEmployee={onAssignEmployee}
          />
        ))}
      </Table>
    </Table.BodyWithInfiniteScroll>
  )
}

export default observer(GroupBody)
